import { TbChevronRight } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const ChevronRightIcon = (props: IconProps) => {
  return <IconBase icon={TbChevronRight} {...props} />;
};
